import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboSalaExtraccionActivo`, method: 'GET', body: null, token: token})
}